// Decide se o mini-onboarding pós-cadastro (Etapa 9 / spec S01) deve
// aparecer: "valor da hora" + "mark-up padrão", uma única vez, logo após um
// CADASTRO bem-sucedido — nunca em todo login.
//
// Por que AsyncStorage e não uma coluna em `profiles`: o schema de
// `profiles` (src/db/schema.ts) é fixo pela spec (id, hourly_rate,
// default_markup_pct, locale, updated_at) e o "decidir depois" já grava 0
// nos dois campos — não dá para distinguir "usuária pulou a pergunta" de
// "usuária nunca respondeu" olhando só para os valores. Uma coluna nova
// exigiria mexer também no trigger do Postgres/migração remota, fora do
// escopo desta etapa. Um flag local simples resolve sem tocar em schema:
// setado em `useAuth.signUp()` quando o cadastro dá certo, checado pelo
// auth-gate (app/_layout.tsx) e limpo assim que a tela de onboarding
// termina (respondida ou pulada).
//
// Guardado por AsyncStorage (não em memória) de propósito: cadastro no
// Supabase pode exigir confirmação de e-mail antes da sessão existir de
// verdade (ver spec S01 "Cadastro"), então pode haver um app kill entre o
// signUp() e a primeira sessão autenticada — o flag precisa sobreviver a
// isso.
import AsyncStorage from '@react-native-async-storage/async-storage';

const KEY_PREFIX = 'crochet:onboarding-pending:';

function keyFor(userId: string): string {
  return `${KEY_PREFIX}${userId}`;
}

/** Chamado por `useAuth.signUp()` quando o cadastro é bem-sucedido. */
export async function markOnboardingPending(userId: string): Promise<void> {
  await AsyncStorage.setItem(keyFor(userId), '1');
}

/** Checado pelo auth-gate (app/_layout.tsx) a cada navegação. */
export async function isOnboardingPending(userId: string): Promise<boolean> {
  const value = await AsyncStorage.getItem(keyFor(userId));
  return value === '1';
}

/** Chamado pela tela de onboarding ao terminar (respondida ou pulada). */
export async function clearOnboardingPending(userId: string): Promise<void> {
  await AsyncStorage.removeItem(keyFor(userId));
}
